export default "__VITE_ASSET__C$Zk0kGt__"